<template>
  <div id="app">
    <router-view></router-view>
    
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      status: 0
    };
  },
  methods: {
    getBaseInfo() {

      const urlParams = new URLSearchParams(window.location.search);
      const tokenload = urlParams.get('tokenload');
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res => {
        if (!localStorage.getItem('token')) {
          if (tokenload ) {
            this.doLoginOrRegister(tokenload);
          }else{
            this.$router.push({ path: '/Login' })
          }
        }
        this.$store.commit('setBaseInfoValue', res.data);
      })
    },

    doLoginOrRegister(tokenParmar){
      this.$http({
        url: "doLoginOrRegister",
        method: "post",
        data: {
          token: tokenParmar,
        },
      }).then((res) => {
        if (res.code === 200) {
          this.$toast.success(this.$t(res.msg));
          localStorage.setItem("token", res.data);
        } else {
          this.$toast(res.msg);
        }
      });
    },

  },
  created() {
    
    this.getBaseInfo();
    
  }
}
</script>

<style>
body .van-toast {
  font-size: 38px;
  padding: 30px;
  line-height: 50px;
  width: 600px;
}

body .van-toast .van-toast__icon {
  font-size: 50px;
}

*,
:after,
:before {
  box-sizing: border-box;
}
.van-picker__cancel, .van-picker__confirm{
  font-size: 32px!important;
  padding: 30px!important;
}
.van-picker__toolbar{
  height: 100px!important;
}

.flex-center{
    display: flex;
    align-items: center;
}
.flex-col{
    flex: 1;
    min-width: 0;
}
</style>
